module.exports = __webpack_public_path__ + "static/media/Vector_2.1eb3b4a5.png";